import type { LucideIcon } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface NavItemProps {
  icon: LucideIcon;
  label: string;
  /** Phase 1 destinations render as disabled placeholders until their own
   * route ships. Omit `to` (or pass `disabled`) for a still-placeholder
   * item; `disabled` and `to` are mutually exclusive by construction, not
   * by a runtime check, since nothing here ever passes both. */
  disabled?: boolean;
  /** The route this item leads to, once it is live. */
  to?: string;
  onClick?: () => void;
}

const CONTENT_CLASS = 'flex items-center gap-2 rounded-card px-3 py-2 text-body';

export function NavItem({ icon: Icon, label, disabled, to, onClick }: NavItemProps) {
  const Icn = <Icon className="h-4 w-4 text-icon-muted" aria-hidden="true" />;

  if (!disabled && to) {
    return (
      <NavLink
        to={to}
        onClick={onClick}
        className={({ isActive }) =>
          `${CONTENT_CLASS} ${isActive ? 'bg-surface-brand-subtle text-fg-primary' : 'text-fg-tertiary hover:bg-state-hover hover:text-fg-primary'}`
        }
      >
        {Icn}
        <span>{label}</span>
      </NavLink>
    );
  }

  return (
    <div
      aria-disabled={disabled}
      title={disabled ? `${label} — coming in Phase 1` : undefined}
      className={`${CONTENT_CLASS} text-fg-tertiary aria-disabled:cursor-not-allowed aria-disabled:opacity-50`}
    >
      {Icn}
      <span>{label}</span>
    </div>
  );
}
